import { Observable } from "rxjs";
import { IGenericFieldOptions, ZnSelectQueryParams } from "../interfaces/IGenericFieldOptions";
import { GenericValidator } from "./generic-validator";
import { FieldDependencyRule } from "./field-dependency";
import { PreAccessFilterOptions } from "../../pre-access-filter/models/pre-access-filter.models";

export class GenericFormField {
  value: any;
  key: string;
  label?: string;
  required: boolean;
  order: number;
  controlType: string;
  type: string;
  step?: string;
  decimalPrecision?: number;
  decimalScale?: number;
  // Dropdown/Radio button options
  options: {key: string; value: string}[];
  optionsLoader?: (
    params?: ZnSelectQueryParams
  ) => Observable<{key: string; value: string}[] | { items: { key: string; value: string }[]; totalCount?: number }>;
  validators: GenericValidator[];
  cssClases?: string | string[];
  hidden?: boolean;
  hiddenByDefault?: boolean;
  readOnly?: boolean;
  showReadOnlyInForm?: boolean;
  prefilter?: PreAccessFilterOptions;
  dependencies?: FieldDependencyRule[];

  constructor(
    options: IGenericFieldOptions = {},
  ) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order ?? 1;
    this.controlType = options.controlType || '';
    this.type = options.type || '';
    this.step = options.step;
    this.decimalPrecision = options.decimalPrecision;
    this.decimalScale = options.decimalScale;
    this.options = options.options || [];
    this.optionsLoader = options.optionsLoader;
    this.validators = options.validators || [];
    this.hidden = options.hidden ?? false;
    this.hiddenByDefault = options.hiddenByDefault ?? false;
    this.readOnly = options.readOnly ?? false;
    this.showReadOnlyInForm = options.showReadOnlyInForm ?? false;
    this.prefilter = options.prefilter;
    this.dependencies = options.dependencies;
  }
}
